import * as actionTypes from '../actionTypes';

export const setFilter = filter => ({ type: actionTypes.filter.SET, filter });
export const setMediumPriorityOnly = () => ({ type: actionTypes.filter.SET_MEDIUM_PRIORITY_ONLY });